///////////////////////////// UTILS ///
import { Store } from '@ngrx/store';
import { AppState } from '../../store/app.states';
import {
  GetQuestionnairesClinicalHBI, GetQuestionnairesClinicalPRISM,
  GetQuestionnairesClinicalSCCAI,
  GetQuestionnairesEORTC,
  GetQuestionnairesEQ5D5L,
  GetQuestionnairesHADS,
  GetQuestionnairesHBI,
  GetQuestionnairesIBDDisk, GetQuestionnairesIBDQ,
  GetQuestionnairesIPAQSF,
  GetQuestionnairesMIAHCD,
  GetQuestionnairesMIAHUC,
  GetQuestionnairesMMAS8,
  GetQuestionnairesPatientSCCAI,
  GetQuestionnairesPHQ9, GetQuestionnairesPRISM,
  GetQuestionnairesPSQI,
  GetQuestionnairesSIBDQ, GetQuestionnairesLARS, GetQuestionnairesTSQM, GetQuestionnairesWPAI,
} from '../../store/actions/doctor.actions';

export class EvaluationDTO {
  date: string;
  evaluation: boolean;

  constructor(date: string, evaluation: boolean) {
    this.date = date;
    this.evaluation = evaluation;
  }
}

export function doctorDispatching(store: Store<AppState>, type, patientSSN) {
  const q = type.toLowerCase();
  switch (q) {
    case 'clinical-sccai':
      store.dispatch(new GetQuestionnairesClinicalSCCAI(patientSSN));
      break;
    case 'clinical-hbi':
      store.dispatch(new GetQuestionnairesClinicalHBI(patientSSN));
      break;
    case 'clinical-prism':
      store.dispatch(new GetQuestionnairesClinicalPRISM(patientSSN));
      break;
    case 'eortc-qlq':
      store.dispatch(new GetQuestionnairesEORTC(patientSSN));
      break;
    case 'eq5d5l':
      store.dispatch(new GetQuestionnairesEQ5D5L(patientSSN));
      break;
    case 'hads':
      store.dispatch(new GetQuestionnairesHADS(patientSSN));
      break;
    case 'hbi':
      store.dispatch(new GetQuestionnairesHBI(patientSSN));
      break;
    case 'ibd-disk':
      store.dispatch(new GetQuestionnairesIBDDisk(patientSSN));
      break;
    case 'ipaq-sf':
      store.dispatch(new GetQuestionnairesIPAQSF(patientSSN));
      break;
    case 'miah-cd':
      store.dispatch(new GetQuestionnairesMIAHCD(patientSSN));
      break;
    case 'miah-uc':
      store.dispatch(new GetQuestionnairesMIAHUC(patientSSN));
      break;
    case 'mmas8':
      store.dispatch(new GetQuestionnairesMMAS8(patientSSN));
      break;
    case 'patient-sccai':
      store.dispatch(new GetQuestionnairesPatientSCCAI(patientSSN));
      break;
    case 'phq9':
      store.dispatch(new GetQuestionnairesPHQ9(patientSSN));
      break;
    case 'prism':
      store.dispatch(new GetQuestionnairesPRISM(patientSSN));
      break;
    case 'psqi':
      store.dispatch(new GetQuestionnairesPSQI(patientSSN));
      break;
    case 'sibdq':
      store.dispatch(new GetQuestionnairesSIBDQ(patientSSN));
      break;
    case 'tsqm':
      store.dispatch(new GetQuestionnairesTSQM(patientSSN));
      break;
    case 'wpai':
      store.dispatch(new GetQuestionnairesWPAI(patientSSN));
      break;
    case 'ibdq':
      store.dispatch(new GetQuestionnairesIBDQ(patientSSN));
      break;
    case 'lars':
      store.dispatch(new GetQuestionnairesLARS(patientSSN));
      break;
  }
}
